<template>
  <section class="contact py-10 md:py-20 bg-white overflow-hidden relative">
    <div class="text-center px-8">
      <h1 class="text-5xl font-bold lg:text-7xl">
        {{ __(errorType + '.title') }}
      </h1>

      <p class="text-gray-400 mt-2 lg:text-xl mb-0 lg:w-3/5 lg:mx-auto">
        {{ __(errorType + '.text') }}
      </p>

      <div class="mt-8">
        <Link
          :href="localeRoute('frontend.index')"
          class="button-orange shadow-button-black block w-full lg:inline-block lg:w-auto lg:px-24"
        >
          {{ __(errorType + '.go-back') }}
        </Link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    errorType: {
      type: String,
      required: true,
    },
  },
};
</script>
